import { Card } from "@chakra-ui/react";
import { useState } from "react";
import RecentActivity from "../components/RecentActivity";
import { useAuth } from "../contexts/AuthContext";
import { useGetMemberByUserIdQuery } from "../features/memberApi";

function RecentActivityPage() {
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);

  const { userId, roles } = useAuth();

  const { data } = useGetMemberByUserIdQuery(userId || "", {
    refetchOnMountOrArgChange: true,
    skip: roles?.includes("ADMIN"),
  });

  const memberId = data?.id;

  const isAdminView = roles?.includes("ADMIN");

  return (
    <Card.Root p={{ base: 4, md: 6 }}>
      <RecentActivity
        limit={limit}
        showTitle={true}
        isAdminView={isAdminView}
        memberId={memberId}
        isViewAll={false}
      />
      {/* <Pagination.Root
        count={limit}
        pageSize={page}
        defaultPage={1}
        onPageChange={(p) => {
          setPage(p.page);
          setLimit(p.pageSize);
        }}
        mt={4}
      >
        <ButtonGroup variant="ghost" size="sm">
          <Pagination.PrevTrigger asChild>
            <IconButton>
              <LuChevronLeft />
            </IconButton>
          </Pagination.PrevTrigger>

          <Pagination.Items
            render={(page) => (
              <IconButton variant={{ base: "ghost", _selected: "outline" }}>
                {page.value}
              </IconButton>
            )}
          />

          <Pagination.NextTrigger asChild>
            <IconButton>
              <LuChevronRight />
            </IconButton>
          </Pagination.NextTrigger>
        </ButtonGroup>
      </Pagination.Root> */}
    </Card.Root>
  );
}

export default RecentActivityPage;
